import { initSessionReplay, setReplayUser } from '@jobtarget/browser-rum';

/** JobTarget session replay. CloudWatch RUM keeps performance, errors and traces. */
export function initReplay(): void {
  initSessionReplay({
    service: 'chimemessaging',
    env: process.env.REACT_APP_RUM_ENV || 'sb',
    version: process.env.REACT_APP_APP_RELEASE,
    // npm has no script tag to infer the intake from; prod intake, prod console.
    ingestOrigin: 'https://rum-replay-intake.jobtarget.com',
  // Replays show what was typed. Passwords, .sr-mask and fields whose name reads
  // as a secret (ssn, card, cvv, pin, token...) stay masked at every level;
  // ordinary fields do not.
    privacy: 'allow',
    sessionReplaySampleRate: 100,
  });

  // The jt-navbar broadcasts the signed-in user; name the session when it arrives.
  // Safe before recording starts: the SDK holds the identity until the token
  // arrives, then sends it once per session rather than once per page.
  window.addEventListener('userinfo:jt:navbar', (event: Event) => {
    const d = (event as CustomEvent<{ user_id?: string; email?: string; company?: { companyId?: number } }>).detail;
    if (!d || (!d.user_id && !d.email)) return;
    void setReplayUser(d.user_id, d.email, { companyId: d.company?.companyId });
  });
  window.dispatchEvent(new CustomEvent('requestuserinfo:jt:navbar'));
}
